<div class="account" *ngIf="selectedStudent && bankActionsForm">
  <div class="account__actions">
    <form
      class="actions__form"
      [formGroup]="bankActionsForm">
      <div class="container-fluid">
        <div class="row align-items-center justify-content-center">
          <div class="col-4 text-right"></div>
          <div class="col-4 text-center">
            <div class="amount" [ngStyle]="{'color': getRewardColor()}">
              {{ studentAmount }}
            </div>
          </div>
          <div class="col-4 text-left">
            <button
              class="actions__form__button actions__form__button_reset"
              type="button"
              [disabled]="studentAmount <= 0"
              (click)="resetAccount()">Снять всё
            </button>
          </div>
        </div>
        <div class="row align-items-center justify-content-center text-center mt-5">
          <div class="col-4 text-right">
            <button
              class="actions__form__button actions__form__button_deposit"
              type="button"
              [disabled]="bankActionsForm.invalid"
              (click)="addToAccount()">Внести
              <span class="fa fa-caret-up button__icon button__icon_deposit"></span>
            </button>
          </div>
          <div class="col-4 text-center">
            <label for="amount" class="actions__form__input__label">
              <input
                formControlName="amount"
                class="actions__form__input untouched"
                type="number"
                id="amount"
                (focus)="onInputFocus()"
                (blur)="onInputBlur()"
                #amountInput>
              <span class="actions__form__input__placeholder" #amountPlaceholder>Введите сумму операции</span>
            </label>
          </div>
          <div class="col-4 text-left">
            <button
              class="actions__form__button actions__form__button_withdraw"
              type="button"
              [disabled]="bankActionsForm.invalid"
              (click)="removeFromAccount()">Снять
              <span class="fa fa-caret-down button__icon button__icon_withdraw"></span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="account__transactions">
    <app-account-transactions 
      [account]="studentAccount"
      [reward_active]="reward_active">
    </app-account-transactions>
  </div>
</div>
